<template>
  <div v-if="open" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

    <div class="fixed inset-0 z-10 overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all">
          <div class="absolute top-0 right-0 pt-4 pr-4">
            <button @click="close_modal" class="text-gray-400 hover:text-gray-500 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <div class="text-center">
            <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 pl-10 pr-10 pb-2">
              {{ nombrecentro}}
            </div>
            <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 pl-10 pr-10 pb-2">
         <b> {{ $t('intervalo') }}</b>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 pl-10 pr-10">
              
              
              
              <div class="p-4">
   
    <select
      id="miSelect"
      v-model="opcionSeleccionada"
      class="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
    >
     <option value="0">{{ $t('seleccionar') }}</option>
      <option value="2">2  {{ $t('horas') }} </option>
      <option value="4">4  {{ $t('horas') }}</option>
      <option value="6">6  {{ $t('horas') }}</option>
      <option value="12">12  {{ $t('horas') }}</option>
      <option value="24">24  {{ $t('horas') }}</option>
    </select>

    
  </div>
          


            </div>

            
          </div>
          <div class="mt-2 sm:mt-2">
          
            <button  @click="handleSetPoint" type="button" class="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm">
              {{ $t('aceptar') }}
            </button>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 
 
 import { ref } from 'vue'
export default {
  props: ['open','edititem','nombrecentro','datos','descripcion'],
  emits: ["updateRangoHoras","closeEditModalHoras","onSend"],
  components: {
 
  },
  data(){
    return{
      enviando : false,
      descripcionSetPoint: '',
      valor: 0,
      openmodal: this.open,
      edititem_modal: this.edititem,
      glosatipo : '',
      opcionSeleccionada : ref("0")
    }
  },

  /*props: {
    open: false,
    edititem: {label: '', value: '',id:''}
  },*/
  methods: {
    onSend( ){  
       this.$emit('updateRangoHoras',  this.opcionSeleccionada)
    },
    onCancel() {
      this.$emit('updateOpen', false)
    },
    close_modal() {
        //console.log('cerrar modal 1');
        this.$emit("close")
    },
   handleSetPoint() {
   
      
      this.enviando=true;
      this.onSend();
 
 
    },
  },
  mounted(){ 
 
     
    this.enviando=false;
  },
  watch:{
    datos: function(dat){ 
     this.valor= dat.value;
    
     this.enviando=false;
    },
    
  },
  computed: {
   
  
  },
}
</script>
